'use client'

import CustomerQuote from '@/components/CustomerQuote'

const PayhawkCustomerQuote = () => (
    <CustomerQuote
        sx={{
            height: {
                xs: `792px`,
                sm: `792px`,
                md: `480px`,
                lg: `480px`,
                xl: `480px`,
            },
        }}
        light={false}
        backgroundImageSrc={'/images/payhawk-case-study/payhawk-quote-oreja-desktop.png'}
        mobileBackgroundImageSrc={'/images/payhawk-case-study/payhawk-quote-oreja-mobile.png'}
        text={
            <>
                My biggest anxiety about finding a partner was whether they were good at both
                emission calculations and carbon offsetting.
                <br />
                <br />
                Sustainability is a tough market, riddled with poor investments that end up on the
                news. I used to work in climate projects, so when I came across Lune I knew they
                were a credible partner for Payhawk.
            </>
        }
        avatar={{
            title: 'Raquel Orejas',
            subtitle: 'Product Marketing Manager at Payhawk',
            imageSrc: '/images/payhawk-case-study/raquel.png',
        }}
        reversedOnMobile
    />
)

export default PayhawkCustomerQuote
